<template>
  <div class="ck-editor">
    <a-form-label
      id="editorLabel"
      for="editor"
    >
      {{ label }}
    </a-form-label>

    <ckeditor
      id="editor"
      ref="value"
      :value="value"
      :editor="editor"
      :config="editorConfig"
      v-bind="$attrs"
      class="form-input"
      @input="$emit('input', $event)"
    />

    <div
      v-if="hasError"
      :id="errorId"
    >
      <a-form-error
        v-for="(error, index) in errors"
        v-if="error.show"
        :key="index"
      >
        {{ error.message }}
      </a-form-error>
    </div>
  </div>
</template>

<script>
import AFormError from '@/components/form/atoms/AFormError'
import AFormLabel from '@/components/form/atoms/AFormLabel'
import CKEditor from '@ckeditor/ckeditor5-vue'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'

export default {
  name: 'CEditor',

  components: {
    AFormError,
    AFormLabel,
    ckeditor: CKEditor.component
  },

  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: [String, Object, Number],
      required: true,
      default: ''
    },
    label: {
      type: String,
      default: 'Inhalt'
    },
    errors: {
      type: Array
    },
    hasError: {
      type: Boolean
    },
    isValid: {
      type: Boolean
    }
  },

  data () {
    return {
      editor: ClassicEditor,
      editorConfig: this.$config.CKCONFIG,
      editorData: ''
    }
  },

  computed: {
    errorId () {
      return this.id + '-error'
    }
  }
}
</script>
<style scoped>
.ck-editor {
  margin-bottom: 2em;
}
</style>
